var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0906 84.9674C66.8251 84.1303 85 65.4391 85 42.5001C85 39.1293 84.6055 35.8508 83.8641 32.7065L65.4671 14.3098L52.8793 33.4901L33.6995 14.3098L31.0285 15.6693L41.2901 51.1492L28.9996 69.8764L44.0906 84.9674Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5834 47.2222H35.4166L19.5329 14.3098H33.6995L49.5834 47.2222Z",
    fill: "#5281A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4166 47.2222H49.5834L65.4671 14.3098H51.3005L35.4166 47.2222Z",
    fill: "#386895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 75.5554C52.9321 75.5554 61.3889 67.0986 61.3889 56.6665C61.3889 46.2345 52.9321 37.7776 42.5 37.7776C32.0679 37.7776 23.6111 46.2345 23.6111 56.6665C23.6111 67.0986 32.0679 75.5554 42.5 75.5554Z",
    fill: "#FF7F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 37.7778C52.9321 37.7778 61.3889 46.2347 61.3889 56.6668C61.3889 67.0989 52.9321 75.5555 42.5 75.5555V37.7778Z",
    fill: "#E03A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 68.4722C49.02 68.4722 54.3055 63.1866 54.3055 56.6666C54.3055 50.1466 49.02 44.8611 42.5 44.8611C35.98 44.8611 30.6945 50.1466 30.6945 56.6666C30.6945 63.1866 35.98 68.4722 42.5 68.4722Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 44.8611C49.0201 44.8611 54.3055 50.1465 54.3055 56.6666C54.3055 63.1867 49.0201 68.4722 42.5 68.4722V44.8611Z",
    fill: "#D48B07"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon3);
export default __webpack_public_path__ + "static/media/priority_icon_3.d9f4725bc50fac54f4a0205957d4bff2.svg";
export { ForwardRef as ReactComponent };